import { CompanyTab } from "./types";

// Filter mappings for each install feature/component
export const INSTALL_FILTER_MAPPINGS = {
  // FAI Components
  FAI_BY_DEPARTMENT: {
    geography: false,
    products: true,
    vendors: true,
    categories: true,
    attributes: true,
    corporate: false,
  },
  FAI_BY_PRODUCT: {
    geography: false,
    products: true,
    vendors: true,
    categories: true,
    attributes: true,
    corporate: false,
  },

  // Install Components
  PRODUCT_INSTALLS: {
    geography: true,
    products: true,
    vendors: true,
    categories: true,
    attributes: true,
    corporate: true,
  },
  INSTALLS_BY_COUNTRY: {
    geography: true,
    products: true,
    vendors: true,
    categories: true,
    attributes: true,
    corporate: false,
  },
  VENDORS_BY_CATEGORY: {
    geography: true,
    products: true,
    vendors: true,
    categories: true,
    attributes: true,
    corporate: false,
  },
  TOP_VENDORS_BY_PRODUCTS: {
    geography: true,
    products: true,
    vendors: true,
    categories: true,
    attributes: false,
    corporate: false,
  },

  // Intensity Components (don't apply filters - for reference only)
  INTENSITY_TREND: {
    geography: false,
    products: false,
    vendors: false,
    categories: false,
    attributes: false,
    corporate: false,
  },
  INTENSITY_MOMENTUM: {
    geography: false,
    products: false,
    vendors: false,
    categories: false,
    attributes: false,
    corporate: false,
  },
  INTENSITY_OVER_TIME: {
    geography: false,
    products: false,
    vendors: false,
    categories: false,
    attributes: false,
    corporate: false,
  },
} as const;

export type FilterMappingKey = keyof typeof INSTALL_FILTER_MAPPINGS;

export const TABS_ORDER = [
  CompanyTab.SUMMARY,
  CompanyTab.SPEND,
  CompanyTab.INSTALL,
  CompanyTab.INTENT,
  CompanyTab.CONTRACT,
];
